import { Input } from "@/components/ui/input";
import { field } from "@/components/ui-kit";
import { dmy } from "@/lib/api";

const Lbl = ({ children }) => <span className="mb-1 block font-mono text-[10px] uppercase tracking-wider text-slate-500">{children}</span>;

export const Fld = ({ label, value, onChange, testId, placeholder }) => (
  <label className="block">
    <Lbl>{label}</Lbl>
    <Input value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className={field} data-testid={testId} />
  </label>
);

export const OrderEditor = ({ o, set, prefix }) => {
  const st = (k) => (v) => set({ ...o, ship_to: { ...o.ship_to, [k]: v } });
  const h = (k) => (v) => set({ ...o, [k]: v });
  const ln = (i, k) => (v) => set({ ...o, lines: o.lines.map((l, j) => (j === i ? { ...l, [k]: v } : l)) });
  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <Fld label="SAP sales order" value={o.sales_order} onChange={h("sales_order")} testId={`${prefix}-so`} />
        <Fld label="Amazon PO number" value={o.po_number} onChange={h("po_number")} testId={`${prefix}-po`} />
        <Fld label="PO date" value={dmy(o.po_date)} onChange={h("po_date")} placeholder="DD/MM/YYYY" testId={`${prefix}-po-date`} />
        <Fld label="Req. delivery date" value={dmy(o.delivery_date)} onChange={h("delivery_date")} placeholder="DD/MM/YYYY" testId={`${prefix}-delivery`} />
        <Fld label="Ship date" value={dmy(o.ship_date)} onChange={h("ship_date")} placeholder="DD/MM/YYYY" testId={`${prefix}-ship-date`} />
        <Fld label="xDock site (blank = auto)" value={o.site_code} onChange={h("site_code")} placeholder="XD2" testId={`${prefix}-site`} />
        <Fld label="Carrier SCAC (blank = default)" value={o.carrier_scac} onChange={h("carrier_scac")} placeholder="AMZR" testId={`${prefix}-scac`} />
        <Fld label="Load no." value={o.load_no} onChange={h("load_no")} testId={`${prefix}-load`} />
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <Fld label="Ship-to FC code" value={o.ship_to.code} onChange={st("code")} placeholder="DET6" testId={`${prefix}-st-code`} />
        <Fld label="Ship-to name" value={o.ship_to.name} onChange={st("name")} testId={`${prefix}-st-name`} />
        <Fld label="Street" value={o.ship_to.street} onChange={st("street")} testId={`${prefix}-st-street`} />
        <Fld label="City" value={o.ship_to.city} onChange={st("city")} testId={`${prefix}-st-city`} />
        <Fld label="State" value={o.ship_to.state} onChange={st("state")} testId={`${prefix}-st-state`} />
        <Fld label="Zip" value={o.ship_to.zip} onChange={st("zip")} testId={`${prefix}-st-zip`} />
        <Fld label="Country" value={o.ship_to.country} onChange={st("country")} testId={`${prefix}-st-country`} />
      </div>
      <div className="space-y-2">
        {o.lines.map((l, i) => (
          <div key={i} className="grid grid-cols-2 gap-2 sm:grid-cols-6" data-testid={`${prefix}-line-${i}`}>
            <Fld label="Item" value={l.line_no} onChange={ln(i, "line_no")} testId={`${prefix}-line-${i}-no`} />
            <Fld label="Material" value={l.material} onChange={ln(i, "material")} testId={`${prefix}-line-${i}-material`} />
            <Fld label="Amazon item" value={l.customer_material} onChange={ln(i, "customer_material")} testId={`${prefix}-line-${i}-kdmat`} />
            <Fld label="Qty" value={l.qty} onChange={ln(i, "qty")} testId={`${prefix}-line-${i}-qty`} />
            <Fld label="UOM" value={l.uom} onChange={ln(i, "uom")} testId={`${prefix}-line-${i}-uom`} />
            <Fld label="Description" value={l.description} onChange={ln(i, "description")} testId={`${prefix}-line-${i}-desc`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const blankOrder = () => ({
  sales_order: "", po_number: "", po_date: "", delivery_date: "", ship_date: "", site_code: "", carrier_scac: "", load_no: "", bol: "", notes: "",
  ship_to: { code: "", name: "", street: "", street2: "", city: "", state: "", zip: "", country: "US" },
  lines: [{ line_no: "10", material: "", customer_material: "", description: "", qty: "", uom: "RL" }],
});
